import { Injectable, HostListener } from '@angular/core';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { LocationStrategy } from '@angular/common';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';

import { Configuration } from '../config/configuration';
@Injectable({
  providedIn: 'root'
})
export class CommonEventService {
  public commonMainObj:any = {
    uploadedFilesData:'',
    priceMatrixRowData:'',
    priceMatrixColData:'',
    wmqId:'',
    assemblyMatrixColData:'',
    assemblyMatrixRowData:'',
    taxInformation:[],
    taxData: [],
    taxableRate :'',
    taxablePrice : "0.00",
    assemblyTaxPric :'',
    componentTaxPrice :'',
    taxable: false,
    resaleNum:'',
    resaleInformation:'',
    resaleNumber: "",
    taxExemptCertiNumber: "",
    taxExemptOutsideCalifornia: "",
    creditCardInfo:'',
    selectedCreditCard:'',
    cardCvvNumber:'',
    cardType:'',
    cardExpiryDate:'',
    cardHolderName:'', //string
    cardNumber:'', //string
    partData:'',
    partDataJson:'',
    quoteItems:'',
    projectID:'',
    shippingOptionResponse: [],
    shippingMethod:'',
    shippingCost:"0.00",
    tempShippingCost:"0.00",
    shippingAccountNumber:'',
    shippingNotes :'',
    orderSummery :{},
    orderSummeryPartData :'',
    orderSummeryquoteItems :'',
    OrdSumNumOfPcbs:'',
    OrdSumPcbTurnTime:'',
    OrdSumPcbCharges:'',
    ordSumEtestCharge :'',
    ordSumTotalCost :'',
    ordSumPcbSubTotal :'',
    pcbSelectedETesting : 'No',
    OrdSumNumOfAssembly:'',
    OrdSumAssemblyTurnTime :'',
    OrdSumAssemblyCharges:'',
    OrdSumComponentCharges:'',
    assemblyComponentTotal:'',
    addressEditPopup: false,
    isGuestUser : false,
    registeredUser : false,
    newUser : false,
    defaultEmail :'',
    orderRedirectUrl:'',
    pcbPromoDiscount:'',
    assemblyPromoDiscount:'',
    componentPromoDiscount:'',
    totalPromoDiscountAmount:'',
    promoCode:'',
    pcbAssemblyPromo : false,
    fileId :'',
    fromWhereReupload:'',
    uploadedFileName :'',
    s3FileName :'',
    exchangeBomData :'',
    bomToBloobFile:'',
    manuallyBomUploded: false,
    userId:'',
    guestEmailInfo:'',
    pcbFinalQuotedata :'',
    pcbQuotePriceInfo:'',
    wqId:'',
    userName:'',
    userPhone  :'',
    usercompany :'',
    sessionCheck:false,
    userData : {},
    pcbType :'',
    email:'',
    maxBoardQuantity:'',
    customQuoteParam:{},
    partNumber:'',
    partRevision:'',
    surfaceFinish:'',
    material:'',
    minHoleSizeSelected:'',
    minSpaceSelected:'',
    minTraceSelected:'',
    minInnerSpaceSelected:'',
    minInnerTraceSelected:'',
    minSpaceInMils:'',
    minTraceInMils:'',
    innerMinSpaceInMils:'',
    innerMinTraceInMils:'',
    minHoleSizeInMils:'',
    indBoardXDim:'',
    indBoardYDim:'',
    layerValue:'',
    itar:'',
    boardDetailsDataObj:{},
    fileUploadedData:{},
    file:'',
    rNumber:'',
    electricalTesting:'',
    electricalTestingPriceVal:'',
    unitPrice:'',
    selectedFabTurntime:'',
    selectedFabQuantity:'',
    selectedAssemblyTurntime:'',
    selectedAssemblyQuantity:'',
    selectedAssemblyPrice:'',
    lotPrice:'',
    viaInPadSelected:'',
    savedBoardDimensions:'',
    selectedLayerVal:'',
    onlyPcb:true,
    bomFileIncluded:false,
    pcbPartData:{},
    stagingPortalUrl : Configuration.stagingPortalUrl,
    notificationData:'',
    primaryCheckCount:{},
    orderID :'',
    orderPlacedData: {},
    numItemsCharging:'',
    initialPrecheck : false,
    bomProcessXlData :'',
    bomProcessData:{},
    uploadedFileFullPath :'',
    uploadedBomFileName :'',
    uploadedFile:'',
    finalBomDataPrices:'',
    bomProcessItemsData:{},
    qtyAssemblies :'',
    assemblySides:'',
    viaInPadData:'',
    selectedFabPrice:'',
    selectedFabTurntimeVal:'',
    customQtyAssemblies:'',
    bottomImagePath:'',
    topImagePath:'',
    autoUploadFileName:'',
    autoUploadFileId:'',
    noPriceForTurntimeQtyCombination:false,
    noPriceForAllTurntimeQtyCombination : false,
    finalBomDataToPurchase : {},
    backToBoardDetails : false,
    exceededNUmOfHoles : false,
    controlledImpedance :'',
    leadFreeProcessing:'',
    saveQuoteAccessUrl:'',
    saveQuoteMessage:'',
    spx:'',
    resaleNumberDataFromAPi:'',
    listOfAllFiles :  [],
    reUploadData : '',
    customAssemblySelected : false,
    invalidUser : false,
    loginEmail:'',
    userSessionMemberId :'',
    isNotAuthChecked : false,
    purchasingPersonDetails :{},
    backToOrderDetails : false,
    selectedCardExpiryMonth : '',
    selectedCardExpiryYear : '',
    assemblyQuoteJson:{},
    selectedFabLotPrice:'',
    taxableBeforeOrderReview : false,
    webPCBQuoteParameters:{},
    openCheck : false,
    accountManagerEmail:'',
    accountManagerName:'',
    accountManagerPhone:'',
    spxNumber:'',
    spxLink:'',
    selectedFabOrgTurntime:'',
    backToCPPPage: false,
    reQuoteCheck:false,
    gerbersProvided:'',
    odbFilesAvailable:'',
    layerOrderProvided:'',
    boardOutlineProvided:'',
    drillFileProvided:'',
    fabDrawingProvided:'',
    assemblyBomAvailable:'',
    customAssemblySides:'',
    customLeadFreeProcessing:'',
    customViaInPadData:'',
    greaterQtyResp:false,
    aqueousSelectOption:'',
    allAvailableComponets : [],
    listOfMpnsSelected : [],
    finalSelectedComponetesSet:'',
    fabIssuesListArray:[],
    bomFileLineItemData:{},
    mpnIndex:'',
    qtyIndex:'',
    refDesignatorIndex:'',
    partNumberIndex:'',
    maufacturerIndex:'',
    backToCppFromQuotePage : false,
    fabErrWarArray : [],
    options:[],
    autoMappingHeaderData:[],
    customQuoteManualBomUpload:false,
    issueActionability:'',
    source:'',
    dashboardData:{},
    tryToSigninOrRegister : false,
    invalidEmail:false,
    invalidEmailErrorMsg:'',
    reUploadPageName:'',
    dashBoardActivityId:'',
    customerPortalUrl:Configuration.customerPortalUrl,
    formattedDate:'',
    formattedTime:'',
    parentDashboardActivityId:'',
    issueDetails:{},
    standardFlowBomIssueswithIds:[],
    bomIssuesListArray : [],
    customBomPricingData:{},
    finalCustomBomPricingData:{
      'okayToBuy':[],
      'issueFound':[],
      'doNotInstall':[],
      'iWillProvide':[],
      'customerSupport':[],
      'recommendations':[],
    },
    bomLineItemsSavedForCustomCpp:{},
    finalLineItemsInCustomCPP:{},
    qtyOfComponentsCannotbeWashed:'',
    refDesignatorCannotBewashed:'',
    bomFileData:'',
    customQtyOfAssemblies:'',
    customBomPriceItems:[],
    sierraRecommendations :[],
    savedBomFileName:'',
    retrivedBomFileDta:'',
    uploadedBomDataItems : {},
    sierraCustomRecommendations:[],
    customS3BomId:'',
    isLineItemModified: false,
    backToPrevPageActivityId:'',
    reQuoteEnable:false
  }
  private domainRegex = /^(?!\d)(?!.*-$)[a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.(?![0-9]+$)[a-zA-Z0-9]{2,63}$/;
  private invalidPattern = /\d-.*\./;
  private pattren2 = /^.*-\d+\.[a-zA-Z0-9]*\d+$/;//to check some-123.com9
  constructor(private router: Router,private toastr: ToastrService, private location: LocationStrategy) { 
    this.commonMainObj.bomProcessData = {
        "bom_properties": {
            "bom_name": ""
        },
        "file": {
            "filename": "",
            "content_type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "contents": [
                {
                    "name": "",
                    "data": []
                }
            ]
        },
        "sheet_mapping": 0,
        "row_mapping": {},
        "column_mapping": {}
    }
    
    this.commonMainObj.standardFlowBomIssueswithIds = [
      {id:153,issueName:'Alternate MPN',actionable:'true',pricingImpct:'likely',turnTimeImpct:'likely',description:''},
      {id:147,issueName:'Cannot Identify Component',actionable:'true',pricingImpct:'likely',turnTimeImpct:'likely',description:''},
      {id:149,issueName:'Long Lead-time',actionable:'true',pricingImpct:'likely',turnTimeImpct:'likely',description:''},
      {id:151,issueName:'Obsolete Part',actionable:'true',pricingImpct:'likely',turnTimeImpct:'likely',description:''},
      {id:148,issueName:'Not In Stock',actionable:'true',pricingImpct:'likely',turnTimeImpct:'likely',description:''},
      {id:150,issueName:'Minimum Quantity Issue',actionable:'true',pricingImpct:'likely',turnTimeImpct:'likely',description:''}
    ]
  }

  validateDomain(domain: string) {
    if(!domain.includes('@') && domain.length > 64){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Maximum length of the email local part should be less than equal to 64 characters";
      return
    }
    if(!domain.includes('@')){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email id should have a local part and domain part separated by '@'.  Example <local part>@<second level domain>.<top level domain>"
      return
    }
    var emailLocalPart = domain.split("@")[0];
    var first_split = domain.split("@")[1];
    //const [domainPart, tldPart] = first_split.split('.');
    const  domainPart = first_split.split('.').slice(0, -1).join('.');
    const tldPart = first_split.split('.').pop();
    // console.log("emailLocalPartcheck1",domain.startsWith(".", 0));
    console.log("emailLocalPart",emailLocalPart);
    console.log("DomainPart",first_split);
    console.log("DomainSubPart",domainPart);
    // console.log("TDLPart",tldPart);
    //local part check
    if(/^\./.test(domain) == true){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email should not start with a dot (.)";
    }else if(/\.$/.test(emailLocalPart)){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email local part should not end with a dot (.)";
    }else if(emailLocalPart.length > 64){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Maximum length of the email local part should be less than equal to 64 characters";
    }else if(/\.\./.test(emailLocalPart) || /\.\./.test(first_split)){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email should not contain consecutive dots (..)";
      //domain part check strt from here
    }else if(/\.$/.test(first_split)){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email domain part should not end with a dot (.)";
    }else if(/[^a-zA-Z0-9_.-]/.test(emailLocalPart)) {
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg ="Invalid characters contains at local part.";
    }else if(domainPart.substring(0, 1).match("\\d") && this.invalidPattern.test(domain.split('@')[1])){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "First character of email domain is numeric, so hyphen is not allowed."
    }else if(tldPart != '' && tldPart !=undefined && tldPart.match(/^\d+$/)){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Top Level Domain cannot be entirely numeric"
    }else if(domainPart.substring(0, 1).match("-")){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "First character of email domain cannot be a hyphen"
    }else if(domainPart.slice(-1).match("-")){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Last character of email domain cannot be a hyphen"
    }else if(first_split.slice(-1).match("-")){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Last character of email domain cannot be a hyphen"
    }else if(/^\s|\s$|\s/.test(domain)){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email id cannot have spaces"
    }else if(!first_split.includes('.')){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Email id should have a dot (.) and top level domain should be present after the dot. Example <local part>@<second level domain>.<top level domain>"
    }else if(tldPart == '' && tldPart == undefined){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Missing Top-level-domain."
    }else if(tldPart != '' && tldPart != undefined && tldPart.length < 2){
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Top-level-domain should contain mininmum 2 characters"
    }else if(first_split && first_split.length > 63) {
      // return domainPart.length + tldPart.length + 1 <= 63; // +1 for the dot
      this.commonMainObj.invalidEmail = true;
      this.commonMainObj.invalidEmailErrorMsg = "Maximum email length should be less than equal to 63 characters";
    }else{
      this.commonMainObj.invalidEmail = false;
    }
    //This condition commented based on OFP-1463
    // else if((first_split.match(/\./g) || []).length > 1){
    //   this.commonMainObj.invalidEmail = true;
    //   this.commonMainObj.invalidEmailErrorMsg = "Email id should coantain only one (.) in the domain part"
    // }
  }

  alertCall(title:any,message:any){
    Swal.fire({
      toast: false,
      showConfirmButton: title.indexOf('while we price the')>=0?false:true,
      showCancelButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      title:title,
      text:message,
      confirmButtonText: 'Ok',
    });
  }
  notificationAlert(title:any,message:any){
    Swal.fire({
      toast: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      title:title,
      html:message,
      confirmButtonText: 'Ok',
    });
  }

  confirmAlert(title:any,message:any,cnfmBtnText:any,calclBtnText:any){
    Swal.fire({
      title: title,
      text:message,
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: cnfmBtnText?cnfmBtnText:'Yes',
      cancelButtonText: calclBtnText?calclBtnText:'No'
    }).then((result) => {
      if (result.isConfirmed) {
        if(cnfmBtnText == 'Re-Upload Files'){
          let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
          element.click();
        }
      } else if (result.isDismissed) {
        this.goBack();
      }
    })
  }

  restrictBrowserButtons(){
    this.commonMainObj.openCheck = false;
    history.pushState({}, '', window.location.href);
    this.location.onPopState(() => {
      history.pushState({}, '', window.location.href);
      if(!this.commonMainObj.openCheck){
        this.restrictBrowserButtonsAlert();
      }
    });
  }
  // public ngOnInit(): void {
  //   history.pushState(null, '');
  
  //   fromEvent(window, 'popstate').subscribe(()=>{
  //   // show prompt or alert
  //   this.restrictBrowserButtons();
  //   })
  // }
  restrictBrowserButtonsAlert(){
    this.commonMainObj.openCheck = true;
    Swal.fire({
      title: 'Alert!',
      text:"Navigating back will result in the loss of data",
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // if(cnfmBtnText == 'Re-Upload Files'){
        //   let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
        //   element.click();
        // }
        this.goBack();
      } else if (result.isDismissed) {
        this.commonMainObj.openCheck = false;
      }
    })
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    console.log('Back button pressed');
    event.preventDefault();
    this.restrictBrowserButtons();
  }

  loadingShow(){
    var message = 'Please Wait...'
    Swal.fire({
      toast: false,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      iconHtml: '<img src="../assets/img/loading-icon.gif" width="50" height="50">',
      title:'',
      text:message,
      customClass:'load-show',
    });
  }

  validationLoadingShow(){
    var message = 'Please Wait...'
    Swal.fire({
      toast: false,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      iconHtml: '<img src="../assets/img/loading-icon.gif" width="50" height="50">',
      title:'',
      text:message,
      customClass:'load-show',
    });
  }

  loadingHide(){
    Swal.close();
  }

  // restrictBrowserButtons(){
  //   window.history.pushState(null, "", null);        
  //   window.onpopstate = function() {
  //       window.history.pushState(null, "", null);
  //   };
  // }
  
  goToFileUploadPage(place:any,pageName:any){
    // if(this.userData.firstName){
    //   this.router.navigateByUrl('/home?data='+localStorage.getItem('encData'));
    // }else{
    this.commonMainObj.fromWhereReupload = place;
    this.commonMainObj.reUploadPageName = pageName;
    $("#customFileUpload2").trigger('click'); 
    $("#customFileUpload2").val('');

      // this.router.navigateByUrl('/home?data='+localStorage.getItem('encData')+'&fileId='+localStorage.getItem('fileId'));
    // }
    
  }

  uploadFiles(event:any){
    if(!event.target.files[0]){
      return false;
    }else{
      this.commonMainObj.reUploadData = event;
      localStorage.setItem('apiSerDataObj','');
      localStorage.setItem('commonDataObj','');
      localStorage.setItem('apDtId','')
      this.commonMainObj.backToBoardDetails = false;
      this.commonMainObj.invalidUser = false;
      this.commonMainObj.onlyPcb = true;
      this.commonMainObj.selectedFabTurntime = '';
      this.commonMainObj.uploadedFile = '';
      this.commonMainObj.backToCPPPage = false;
      this.commonMainObj.reQuoteCheck = false;
      this.commonMainObj.backToCppFromQuotePage = false;
      this.commonMainObj.autoUploadFileName = '';
      this.commonMainObj.fabErrWarArray = [];
      this.router.navigateByUrl('/home?data='+localStorage.getItem('encData')+'&fileId='+localStorage.getItem('fileId'));
    }
  }

  goBack(){
    localStorage.setItem('apiSerDataObj','');
    localStorage.setItem('commonDataObj','');
    localStorage.setItem('apDtId','');
    window.location.href= this.commonMainObj.stagingPortalUrl;
  }

  showtoast(message:any,type:any) {
    if(type == 'warning'){
      this.toastr.error(message, 'Alert!!',{
        timeOut:3500,
        positionClass: 'toast-center-center'
      });
    }else if(type == 'success'){
      this.toastr.success(message, 'success!',{
        timeOut:2000,
        positionClass: 'toast-center-center'
      });
    }else if(type == 'error'){
      this.toastr.error(message, 'Error!',{
        timeOut:2000,
        positionClass: 'toast-center-center'
      });
    }
    
  }

  removeRedBorder(id:any){
    if($('#'+id).val() != ''){
      $('#'+id).removeClass('border-red');
    }else{
      $('#'+id).addClass('border-red');
    }
  }

  restrictRefreshButton(){
    // window.addEventListener("beforeunload", this.onBeforeUnload);
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    // Confirmation message
    const confirmationMessage = 'Are you sure you want to leave this page?';
    // Set the confirmation message
    event.returnValue = confirmationMessage;
    // Return the confirmation message
    return confirmationMessage;
  }

  destroyRefreshEvent(){
    // window.removeEventListener("beforeunload", this.onBeforeUnload);
  };

  bomConfirmAlert(title:any){
    return new Promise((resolve,reject)=>{ 
      Swal.fire({
        title: 'Alert!',
        // text:title,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        allowOutsideClick: false,
        html:title,
        customClass:'modal_popup_custom',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then(result => {
        return resolve(result);
      },error=>{
        return resolve(error);
      });
    });
  }

  confirmAlertFn(title:any){
    return new Promise((resolve,reject)=>{ 
      Swal.fire({
        title: 'Alert!',
        text:title,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then(result => {
        return resolve(result);
      },error=>{
        return resolve(error);
      });
    });
  }

  issuesListObjFn(){
    if(this.commonMainObj.fabErrWarArray.length>0){
      this.commonMainObj.fabIssuesListArray = [];
      for(var errIndx in this.commonMainObj.fabErrWarArray){
        if(this.commonMainObj.fabErrWarArray[errIndx]['ist_details']){
          this.commonMainObj.issueActionability = this.commonMainObj.pcbType == "Custom/Advanced PCB" ? this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].actionability.custom_quote :this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].actionability.online;
          var issuesListObj = {
            "issueName":this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].issue,
            "issueDetail":this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].details,
            "cisMastIssueActionability":{
              "actionable": this.commonMainObj.issueActionability == "Actionable" ? '1' : '0',
              "fyiOnly" : this.commonMainObj.issueActionability == "FYI Only" ? '1' : '0'
            },
            "cisMastIssuePricingImpact":{
              "dontKnow": "0",
              "likely": this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].pricing_impact == "Likely" ? "1":"0",
              "unlikely": this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].pricing_impact == "Unlikely" ? "1":"0"
            },
            "cisMastIssueTurntimeImpact":{
              "dontKnow": "0",
              "likely": this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].turntime_impact == "Likely" ? "1":"0",
              "unlikely": this.commonMainObj.fabErrWarArray[errIndx]['ist_details'].turntime_impact == "Unlikely" ? "1":"0"
            }
          }
          this.commonMainObj.fabIssuesListArray.push(issuesListObj);
        }
      }
    }
    if(this.commonMainObj.onlyPcb == false && this.commonMainObj.pcbType != "Custom/Advanced PCB"){
      if(this.commonMainObj.finalBomDataToPurchase.issueFound && this.commonMainObj.finalBomDataToPurchase.issueFound.items.length>0){
        for(let issIndx in this.commonMainObj.finalBomDataToPurchase.issueFound.items){
          for(let listIssIndx in this.commonMainObj.standardFlowBomIssueswithIds){
            if(this.commonMainObj.finalBomDataToPurchase.issueFound.items[issIndx]['issueName'] == this.commonMainObj.standardFlowBomIssueswithIds[listIssIndx]['issueName'] || this.commonMainObj.finalBomDataToPurchase.issueFound.items[issIndx]['issueName'].indexOf('Alternate MPN')>0 && this.commonMainObj.standardFlowBomIssueswithIds[listIssIndx]['issueName'].indexOf('Alternate MPN')>=0){
              this.bomIssuesListFn(this.commonMainObj.finalBomDataToPurchase.issueFound.items[issIndx],this.commonMainObj.standardFlowBomIssueswithIds[listIssIndx])
            }
          }
        }
      }
      if(this.commonMainObj.finalBomDataToPurchase.customerSupport && this.commonMainObj.finalBomDataToPurchase.customerSupport.items.length>0){
        for(let issSupportIndx in this.commonMainObj.finalBomDataToPurchase.customerSupport.items){
          let bomIssuesObj = {
            "bomComponentId":this.commonMainObj.finalBomDataToPurchase.customerSupport.items[issSupportIndx]['bomComponentId'],
            "issueId":306,
            "issueDetail":'Customer has asked for Sierra customer service. For this MPN '+this.commonMainObj.finalBomDataToPurchase.customerSupport.items[issSupportIndx]['mpn']+' Please access the request and provide the necessary solution',
            "cisMastIssueActionability":{
              "actionable": '1',
              "fyiOnly" : '0'
            },
            "cisMastIssuePricingImpact":{
              "dontKnow": "0",
              "likely": "1",
              "unlikely": "0"
            },
            "cisMastIssueTurntimeImpact":{
              "dontKnow": "0",
              "likely": "1",
              "unlikely": "0"
            }
          }
          this.commonMainObj.bomIssuesListArray.push(bomIssuesObj);
        }
      }
    }

    // if(this.commonMainObj.uploadedFilesData.fileWarnings.length>0){
    //   for(var warIndx in this.commonMainObj.uploadedFilesData.fileWarnings){
    //     if(this.commonMainObj.uploadedFilesData.fileWarnings[warIndx]['ist_details']){
    //       var warIssuesListObj = {
    //         "issueName":this.commonMainObj.uploadedFilesData.fileWarnings[warIndx]['ist_details'].issue,
    //         "issueDetail":this.commonMainObj.uploadedFilesData.fileWarnings[warIndx]['ist_details'].details
    //       }
    //       this.commonMainObj.fabIssuesListArray.push(warIssuesListObj);
    //     }
    //   }
    // }
  }

  bomIssuesListFn(mainLineItemData:any,issueIdsObj:any){
    if(issueIdsObj.id == 153){
      issueIdsObj.description =  mainLineItemData['mpn']  +' is not available. For ease of sourcing, Alternate MPN '+mainLineItemData.altMpn +' is suggested.'
    }else if(issueIdsObj.id == 147){
      issueIdsObj.description =  mainLineItemData['mpn']  +' can not be identified. Please check whether you have the right MPN.'
    }else if(issueIdsObj.id == 149){
      issueIdsObj.description =  mainLineItemData['mpn'] +' is not in stock. Estimated lead time is high.'
    }else if(issueIdsObj.id == 151){
      issueIdsObj.description =  mainLineItemData['mpn']  + ' is identified as obsolete.'
    }else if(issueIdsObj.id == 148){
      issueIdsObj.description =  mainLineItemData['mpn'] +' is not in stock.'
    }else if (issueIdsObj.id == 150){
      issueIdsObj.description =  mainLineItemData['mpn'] +' is available but the required Minimum Order Quantity (MOQ) is more than required Qty.'
    }
    let bomIssuesObj = {
      "bomComponentId":mainLineItemData['bomComponentId'],
      "issueId":issueIdsObj['id'],
      "issueDetail":issueIdsObj['description'],
      "cisMastIssueActionability":{
        "actionable": issueIdsObj['actionable'] == 'true'?'1':'0',
        "fyiOnly" : issueIdsObj['actionable'] == "FYI Only" ? '1' : '0'
      },
      "cisMastIssuePricingImpact":{
        "dontKnow": "0",
        "likely": issueIdsObj['pricingImpct'] == "likely" ? "1":"0",
        "unlikely": issueIdsObj['pricingImpct'] == "unlikely" ? "1":"0"
      },
      "cisMastIssueTurntimeImpact":{
        "dontKnow": "0",
        "likely": issueIdsObj['turnTimeImpct'] == "likely" ? "1":"0",
        "unlikely": issueIdsObj['turnTimeImpct'] == "unlikely" ? "1":"0"
      }
    }
    this.commonMainObj.bomIssuesListArray.push(bomIssuesObj);
  }

  sessionPortalLoad(){
    // $('#iframeContainer').show();
    // $('#dynamicIframe').attr('src', '');
    $('#dynamicIframe').attr('src', this.commonMainObj.customerPortalUrl);
    // setTimeout(()=>{
    //   var iframe:any = document.getElementById('dynamicIframe');
    //   var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    //   console.log(iframeDocument)
    // //   $('#dynamicIframe').attr('src', '');
    // },2000);
  }

  formattingCurrentDateTime(){
    let date = new Date();
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    let day = String(date.getDate()).padStart(2, '0');
    let year = date.getFullYear();

    let hours = String(date.getHours()).padStart(2, '0'); // 24-hour format
    let minutes = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');

    this.commonMainObj.formattedDate = `${month}/${day}/${year}`;
    this.commonMainObj.formattedTime = `${hours}:${minutes}:${seconds}`;

  }

}
